export default "/images/vendor/flag-icon-css/flags/1x1/jp.svg?da55e778c0af59e1b7ba6a65bd7c986b";